import { ReactNode } from "react";
import { ASSETS_ROUTES } from "../../../lib/common/constants";

type TLifestyleOverlayCardProps = {
    imageSrc?: string;
    imageAlt: string;
    href?: string;
    title?: ReactNode;
    line1?: ReactNode;
    line2?: ReactNode;
    line3?: ReactNode;
    className?: string;
};

export const LifestyleOverlayCard = ({ imageSrc, imageAlt, href, title, line1, line2, line3, className }: TLifestyleOverlayCardProps) => {
    return (
        <div className={`card border-0 w-100 lifestyle-card ${className}`}>
            <img className="card-img lifestyle-card__image" src={imageSrc} alt={imageAlt} />
            <div className="lifestyle-card__overlay"></div>
            <div className="card-body lifestyle-card__body text-white">
                <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className="card-title d-inline-block mb-2 fw-bold text-reset text-decoration-none lifestyle-card__title"
                >
                    <strong>{title}</strong>
                </a>
                {line1 && <p className="mb-0 card-text small lifestyle-card__detail">{line1}</p>}
                {line2 && <p className="mb-0 card-text small lifestyle-card__detail">{line2}</p>}
                {line3 && <p className="mb-0 card-text small lifestyle-card__detail">{line3}</p>}
                <img className="lifestyle-card__mark" src={ASSETS_ROUTES.IMGS.logo} alt="" aria-hidden="true" />
            </div>
        </div>
    );
};
